import React from 'react'
import BlogPost from './BlogPost'
export default function New() {
  return (
    <>
      <BlogPost />
    </>
  )
}
